import {Component} from '@angular/core';
import {Validators, UntypedFormBuilder} from '@angular/forms';
import {compareValidator} from '../../shared/directives/compare-validator.directive';
import {MyProfileService} from '../service/my-profile.service';
import {Alert} from '../../shared/alert.model';
import {getAlertMessage} from '../../shared/api-loaders';
import {ClaimsService} from '../../shared/claims.service';
import { ChangePasswordRequest } from '../model/change-password-request';
import { PasswordValidationService } from '../../shared/services/password-validation.service';
import { PlatformIdmService } from '@platform-idm/sdk-angular';

@Component({
    selector: 're-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent {


  changePasswordForm = this.fb.group({
    oldPassword: ['******', Validators.required],
    newPassword: ['', Validators.required],
    confirmPassword: ['', [Validators.required, compareValidator('newPassword')]]
  });
  edit: boolean;
  alert: Alert;
  showMessage: boolean;
  // Password Requirements


  // @Output() editEvent = new EventEmitter<boolean>();

  constructor(private fb: UntypedFormBuilder, private myProfileService: MyProfileService, private claimsService: ClaimsService,
    private passwordValidationSvc: PasswordValidationService,
    private authService: PlatformIdmService) {
  }


  clickEdit() {
    this.edit = !this.edit;
    this.changePasswordForm.patchValue({oldPassword: ''})
  }

  cancel() {
    this.edit = !this.edit;
    this.changePasswordForm.reset({oldPassword: '******'});
  }

  async onSubmit() {
    // TODO: get the id from userInfo
    this.myProfile_ChangePassword(this.claimsService.getSsoId() , this.changePasswordForm.value);
  }

  clearAlerts() {
    this.alert = null;
    setTimeout(() => this.showMessage = false, 5000);
  }

  myProfile_ChangePassword(id: string, body: ChangePasswordRequest): void {
    this.myProfileService
      .myProfile_ChangePassword(id, body)
      .subscribe(
        res => {
          this.showMessage = true;
          this.cancel();
          this.clearAlerts();
        },
        error => {
          this.alert = getAlertMessage(error);
        });
  }

  // TODO: Have to revisit and see if we can move this to a custom directive.
  valueChange() {
  }

  validatePassword() {
    return this.passwordValidationSvc.validatePassword(this.changePasswordForm.value.newPassword, this.claimsService.getPreferredName(), null, this.claimsService.getFirstName(), this.claimsService.getLastName(), true, true, true).isValid();

    //return this.lowerCase && this.upperCase && this.numberCase && this.specialCharacterCase && this.minLengthCase && this.fName && this.lName && this.uName;
  }

}
